import type { TPage, TPages } from './type';
import { INITIAL_PATH } from '@/constants';
import ACCESSORIAL_CHARGES_ROUTES from '@features/AccessorialCharges/AccessorialCharges.router';
import FREIGHT_BILL_ROUTES from '@features/FreightBill/FreightBill.router';
import DASHBOARD_ROUTES from '@features/Dashboard/Dashboard.router';
import RATE_ROUTES from '@features/Rate/Rate.router';

export const STATIC_PAGES = {
  MAIN: {
    name: 'Sign In',
    path: `${INITIAL_PATH}/sign-in`,
  },
  SIGN_IN: {
    name: 'Sign In',
    path: `${INITIAL_PATH}/sign-in`,
  },
  SIGN_UP: {
    name: 'Sign Up',
    path: `${INITIAL_PATH}/sign-up`,
  },
  FORGET_PASSWORD: {
    name: 'Forget Password',
    path: `${INITIAL_PATH}/forget-password`,
  },
  NOT_FOUND: {
    path: `${INITIAL_PATH}/404`,
  },
};

// ID = URL DE API DE MENU
// PATH = URL LOCAL DEL FRONT
export const PAGES: Record<TPages, TPage> = {
  API_CLIENTS: {
    id: 'api-clients',
    name: 'Clients Api',
    path: `${INITIAL_PATH}/api-clients`,
  },
  ...FREIGHT_BILL_ROUTES.PAGES,
  ...ACCESSORIAL_CHARGES_ROUTES.PAGES,
  ...DASHBOARD_ROUTES.PAGES,
  ...RATE_ROUTES.PAGES,
};

export const getVisiblePages = (): TPage[] => {
  return Object.values(PAGES).filter((page) => !page.hidden);
};

export const getPageById = (id: string): TPage | undefined => {
  return Object.values(PAGES).find((page) => page.id === id);
};

export const getPageByPath = (path: string): TPage | undefined => {
  return Object.values(PAGES).find((page) => {
    const pagePath = page.path.replace(/:[^/]+(\?)?/g, '[^/]+');
    const regex = new RegExp(`^${pagePath.replace(/\//g, '\\/')}$`);
    return regex.test(path);
  });
};
